import revive_payload_client_4sVQNw7RlN from "/app/dev/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/dev/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/dev/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/dev/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/dev/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/dev/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/dev/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/dev/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/dev/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/dev/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import clickOutside_C8jIyDRU4O from "/app/dev/plugins/clickOutside.js";
import initial_data_lKRJEMtQLN from "/app/dev/plugins/initial-data.js";
import recaptcha_W4US4xmBV6 from "/app/dev/plugins/recaptcha.js";
import sentry_client_GoGQuZo4Et from "/app/dev/plugins/sentry.client.js";
import typograph_5DxQj8Q51f from "/app/dev/plugins/typograph.js";
import vue_final_modal_6X7LqUlyAl from "/app/dev/plugins/vue-final-modal.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  clickOutside_C8jIyDRU4O,
  initial_data_lKRJEMtQLN,
  recaptcha_W4US4xmBV6,
  sentry_client_GoGQuZo4Et,
  typograph_5DxQj8Q51f,
  vue_final_modal_6X7LqUlyAl
]